import React from "react";
import { useState, useEffect } from "react";
import PageHeader from "@features/shared/components/PageHeader";
import DRMSummary from "../Components/DRMPlanning/DRM_Summary";
import { getAllMeeting } from "../services/DRM/getAllMeeting";
import { connect, useSelector } from "react-redux";

const DRM = () => {
  const [meetingsummary, setMeetingSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [feedbackloading, setfeedbackLoading] = useState(false);
  const [failedOpen, setFailesOpen] = useState(false);
  const userEmailid = useSelector(
    (state) => state?.userDetails?.details?.Email
  );
  const [snackerror, setSnackError] = useState("");
  const [noMeeting] = useState(false);

  const handleOnClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFailesOpen(false);
  };

  useEffect(() => {
    const fetchMeetings = async () => {
      try {
        setLoading(true);
        const response = await getAllMeeting({ userEmailid });
        if (response?.success) {
          setMeetingSummary(response.data.records);
          setLoading(false);
        } else {
          setSnackError(response?.msg);
          setLoading(false);
          // setMeetingSummary()
          setFailesOpen(true);
        }
      } catch (error) {
        console.error("Error fetching meetings:", error);
        setSnackError(error);
      }
    };

    fetchMeetings();
  }, [userEmailid]);

  return (
    <>
      <PageHeader title="DRM Summary" path="/" />
      <DRMSummary
        noMeeting={noMeeting}
        meetingsummary={meetingsummary}
        setLoading={setLoading}
        setFailesOpen={setFailesOpen}
        feedbackloading={feedbackloading}
        setfeedbackLoading={setfeedbackLoading}
        setSnackError={setSnackError}
        loading={loading}
        failedOpen={failedOpen}
        handleOnClose={handleOnClose}
        snackerror={snackerror}
      />
    </>
  );
};

export default connect(null, {getAllMeeting})(DRM);
